import React, { useEffect, useState } from "react";
import { Stepper, Step } from "react-form-stepper";
import "../styles/sellcar.css"; 
 
import { useDispatch, useSelector } from "react-redux";
 
import { toast } from 'react-toastify';
import { createBooking ,resetState} from "../features/booking/bookingSlice";
import Meta from "../components/Meta";
 import { getAllProducts } from "../features/products/productSlice";
import { Link, useLocation, useNavigate } from "react-router-dom";
  import { MdKeyboardBackspace } from "react-icons/md";
import "../styles/listing.css"
  import noResults from "../images/no_result.gif";
import { useMediaQuery } from "react-responsive";
import ProductCard from "../components/ProductCard";
import FilterForm from "../components/FilterForm";
import Container from "../components/Container";
import { brandByModel } from "../utils/brandsData";
import Pagination from "../components/Pagination";
 

const Sellcar = () => {
  const [currentStep, setCurrentStep] = useState(0);
   const imgState = useSelector((state) => state.upload.images);
   const imgDescState = useSelector((state) => state.upload.descImages);
     const dispatch = useDispatch();
  

 

   const [vehicleDetails, setVehicleDetails] = useState({
 
    make: "",
    model: "",
    year: "",    

  });

  

  const [contactDetails, setContactDetails] = useState({
    name: "",
    email: "",
    phone: "",
    contactMethod: "",  
  });

 

  const handleNextStep = () => {
     if (currentStep === 0) {
   
      const requiredFields = [ "make", "model", "year",   ];
      
      const isVehicleDetailsComplete = requiredFields.every((field) => vehicleDetails[field]?.trim() !== "");
  
      if (!isVehicleDetailsComplete) {
        toast.error("Please fill in all required vehicle details before proceeding.");
        return;
      }
      setCurrentStep(1);
    } else if (currentStep === 1) {
     
      const contactRequiredFields = ["name", "email", "phone",   "contactMethod"];
      
      const isContactDetailsComplete = contactRequiredFields.every((field) => contactDetails[field]?.trim() !== "");
  
      if (!isContactDetailsComplete) {
        toast.error("Please fill in all required contact details before proceeding.");
        return;
      }
  
    
      localStorage.setItem("uploadedImages", JSON.stringify(imgState));
      localStorage.setItem("uploadedDescImages", JSON.stringify(imgDescState));
      setCurrentStep(2);
    }
  };
  
  

  const handlePrevStep = () => {
    setCurrentStep((prev) => Math.max(prev - 1, 0));
  };

  const handleChange = (e) => {
    setVehicleDetails({ ...vehicleDetails, [e.target.name]: e.target.value });
  };


 

  const handleContactChange = (e) => {
    setContactDetails({ ...contactDetails, [e.target.name]: e.target.value });
  };

  const [bookingSuccess, setBookingSuccess] = useState(false);


  const { isSuccess, isError, message, isLoading } = useSelector((state) => state.booking);


  useEffect(() => {
    if (isSuccess) {
      toast.success("Booking Created successfully!");
      
  
    
    
      setBookingSuccess(true);
  
 
      dispatch(resetState());
    }
  
    if (isError) {
      toast.error(message || "Something went wrong!");
    }
  }, [isSuccess, isError, message, dispatch]);

  const handleSubmit = () => {
    const bookingData = {
     
      vehicleDetails,
      contactDetails,
  
    };
  
    dispatch(createBooking(bookingData))
 
  };


 
       const [grid, setGrid] = useState(4);
  const productState = useSelector((state) => state?.product?.product);
 
    const isDesktop = useMediaQuery({ minWidth: 768 });

  // Filter States
  const [tag, setTag] = useState(null)
  const [category, setCategory] = useState(null)
  const [brand, setBrand] = useState(null)
  const [minPrice,setMinPrice]=useState(null)
  const [maxPrice, setMaxPrice] = useState(null)
  const [sort,setSort]=useState(null)
  const [vehicleBrand, setVehicleBrand] = useState("");
  const [brandModel, setBrandModel] = useState("");
  const [minYear, setMinYear] = useState("");
  const [maxYear, setMaxYear] = useState("");
  
  const [selectedBudget, setSelectedBudget] = useState(null);
 const navigate=useNavigate();
  const location = useLocation();
  const searchQuery = new URLSearchParams(location.search).get("search");
  const [showFilter, setShowFilter] = useState(false); 

  const [filteredProducts, setFilteredProducts] = useState([]);

   const [selectedEngineSize, setSelectedEngineSize] = useState(null);


   useEffect(() => {
    getProducts();
  }, [sort, tag, brand, category, minPrice, maxPrice]);
  const getProducts = () => {
    dispatch(getAllProducts({ sort, tag, brand, category, minPrice, maxPrice }));
   };

   useEffect(() => {
    if (!productState) return;

    const overSeas = productState.filter(
      (item) => item.market?.toLowerCase() === "overseas"
    );

    setFilteredProducts(overSeas);
  }, [productState]);

    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 15;
    const pageCount = Math.ceil(filteredProducts.length / itemsPerPage);
    
const handlePageChange = (selectedPage) => {
  setCurrentPage(selectedPage.selected);

  // Smooth scroll to top of product list
  const headerOffset = 120; 
  const element = document.querySelector(".search-container");

  if (element) {
    const top = element.offsetTop - headerOffset;

    window.scrollTo({
      top,
      behavior: "smooth",
    });
  }
};


  const startIndex = currentPage * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentItems = Array.isArray(filteredProducts)
  ? filteredProducts.slice(startIndex, endIndex)
  : [];  

 useEffect(() => {
      const queryParams = new URLSearchParams(location.search);
      const engineSize = queryParams.get("engine_size");  
    
      if (engineSize) {
        setSelectedEngineSize(engineSize);  
      }
    
     
    }, [location.search]);

      
 
    
  const handleBackButtonClick = () => {
    setShowFilter(false);
    document.body.style.overflow = "auto";  
  };
  
 
  
  const handleSearch = () => {
    document.body.style.overflow = "auto"
  }


    const renderFilter = () => {
      return (
        <div className="shop-by-media">
      
                  <div className="filter-back-btn-wrapper">
            <Link 
              className="filter-btn-container1"
              onClick={handleBackButtonClick}>
              <MdKeyboardBackspace className="filter-back-icon" />
              <h2>Filter</h2>
            </Link>
          </div>
        <form onSubmit={handleSubmit} className="media-filter  filter-main-wrapper">
        <div className="filter-card-el">
          <h3 className="filter-title">Brand & Model</h3>
          <div className="d-flex flex-column align-items-center gap-10">
     
            <div className="form-floating w-100">
              <select
                className="form-select"
                value={vehicleBrand}
                onChange={handleBrandChange}
               
              >
                <option value="">Select Brand</option>
                {Object.keys(brandByModel).map((brand) => (
                  <option key={brand} value={brand}>
                    {brand}
                  </option>
                ))}
              </select>
              <label htmlFor="floatingSelect">Brand</label>
            </div>
      
    
            <div className="form-floating w-100">
              <select
                className="form-select"
                value={brandModel}
                onChange={(e) => setBrandModel(e.target.value)}
                disabled={!vehicleBrand}  
              >
                <option value="">Select Model</option>
                {brandByModel[vehicleBrand]?.map((model, index) => (
                  <option key={index} value={model}>
                    {model}
                  </option>
                ))}
              </select>
              <label htmlFor="floatingSelect">Model</label>
            </div>
          </div>
        </div>
      
        <div className="filter-card-el">
          <h3 className="filter-title">Year of Manufacture</h3>
          <div className="d-flex align-items-center gap-10">
            <div className="form-floating">
              <input
                type="text"
                className="form-control"
                placeholder="Min YOM"
                value={minYear}
                onChange={(e) => setMinYear(e.target.value)}
              />
              <label htmlFor="floatingInput">Min YOM</label>
            </div>
            <div className="form-floating">
              <input
                type="text"
                className="form-control"
                placeholder="Max YOM"
                
                value={maxYear}
                onChange={(e) => setMaxYear(e.target.value)}
              />
              <label htmlFor="floatingInput1">Max YOM</label>
            </div>
          </div>
        </div>
  
        <div className="filter-card-el">
    <h3 className="filter-title">Filter by Engine Size</h3>
    <div className="engine-size-container   ">
      <ul className="mt-3">
        {engineSizes.map((size, index) => (
          <li key={index}>
          <button 
            className={`btn ${selectedEngineSize?.trim().toLowerCase() === size.trim().toLowerCase() ? "selected-size" : " "}`}
            onClick={() => handleEngineSizeFilter(size)}
          >
            {size}
          </button>
  
  
          </li>
        ))}
      </ul>
    </div>
  </div>
      
        {/* Filter by Budget */}
        <div className="filter-card-el mb-3">
          <h3 className="filter-title">Filter by Budget</h3>
          <ul className="budget-filter-element">
            <li
              className={selectedBudget?.[0] === 0 && selectedBudget?.[1] === 500000 ? 'selected' : ''}
              onClick={() => handleBudgetFilter(0, 500000)}
            >
              0-500K
            </li>
            <li
              className={selectedBudget?.[0] === 500000 && selectedBudget?.[1] === 1000000 ? 'selected' : ''}
              onClick={() => handleBudgetFilter(500000, 1000000)}
            >
              500K-1M
            </li>
            <li
              className={selectedBudget?.[0] === 1000000 && selectedBudget?.[1] === 2000000 ? 'selected' : ''}
              onClick={() => handleBudgetFilter(1000000, 2000000)}
            >
              1M-2M
            </li>
            <li
              className={selectedBudget?.[0] === 2000000 && selectedBudget?.[1] === 3000000 ? 'selected' : ''}
              onClick={() => handleBudgetFilter(2000000, 3000000)}
            >
              2M-3M
            </li>
            <li
              className={selectedBudget?.[0] === 3000000 && selectedBudget?.[1] === 5000000 ? 'selected' : ''}
              onClick={() => handleBudgetFilter(3000000, 5000000)}
            >
              3M-5M
            </li>
            <li
              className={selectedBudget?.[0] === 5000000 && selectedBudget?.[1] === 10000000 ? 'selected' : ''}
              onClick={() => handleBudgetFilter(5000000, 10000000)}
            >
              5M-10M
            </li>
            <li
              className={selectedBudget?.[0] === 10000000 && selectedBudget?.[1] === Infinity ? 'selected' : ''}
              onClick={() => handleBudgetFilter(10000000, Infinity)}
            >
              Above 10M
            </li>
            {selectedBudget && (
              <button type="button" className="clear-btn" onClick={clearBudgetFilter}>
                Clear
              </button>
            )}
          </ul>
        </div>
      
        <button type="submit" className="btn" onClick={handleSearch}>Search</button>
      </form>
        </div>
  
               
      );
    };
  
 
 
  
  const engineSizes = Array.from(
    new Set(productState?.map(item => item.engineSize?.title).filter(Boolean))  
  );
  
   
  const handleEngineSizeFilter = (size) => {
    setSelectedEngineSize(size);
     document.body.style.overflow = "auto"
   };

  const handleBrandChange = (e) => {
    setVehicleBrand(e.target.value);
    setBrandModel("");  
  };

  const handleBudgetFilter = (min, max) => {
    setSelectedBudget([min, max]);
    setMinPrice(min);
    setMaxPrice(max);
};


  const clearBudgetFilter = () => {
    setSelectedBudget(null);
 
  };

  useEffect(() => {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
}, [currentStep]);


  return (
    <>
<Meta 
  title="Import With Us | Matel Trading Motors" 
  description="We import and sell high-quality used cars from Japan, Thailand, the UK, and Singapore. Enjoy a seamless, personalized car importation experience in Kenya with Matel Trading Motors."
  keywords="import cars to Kenya, car import services Kenya, Japanese cars Kenya, UK car imports Kenya, Thailand car imports Kenya, Singapore car imports Kenya, affordable car import Kenya, car import process Kenya"
  canonical="https://mateltradingmotors.com/import-with-us"
/>

    <div className="import-wrapper">
<div className="sellcar-container">
      {bookingSuccess ? (
  <div className="success-message">
    <h2>Your booking has been received!</h2>
    <p>Kindly wait for our team to reach out to you as soon as possible.</p>
     <button><a href="/">Go to Homepage</a></button>
  </div>
) :(
  <>

        <h2 className="sellcar-header">
        Fill out the form if you want us to import a car for you
      </h2>
 
<Stepper
  activeStep={currentStep}
  className="custom-stepper"
>
  <Step label="Vehicle Details" 
        className="step"
        activeClassName="active-step"
        completedClassName="completed-step"
  />
  <Step label="Contact Details" 
        className="step"
        activeClassName="active-step"
        completedClassName="completed-step"
  />
  <Step label="Review & Submit" 
        className="step"
        activeClassName="active-step"
        completedClassName="completed-step"
  />
</Stepper>


 

  {currentStep === 0 && (
    <div className="vehicle-details">
      <h2 className="title">Enter Vehicle Details</h2>

      <form>

 

<label>
<span className="required">Make:</span>
<input type="text" name="make" value={vehicleDetails.make} onChange={handleChange} required />
</label>

<label>
<span className="required">Model:</span>
<input type="text" name="model" value={vehicleDetails.model} onChange={handleChange} required />
</label>

<label>
  <span className="required">Year:</span>
  <select name="year" value={vehicleDetails.year} onChange={handleChange} required>
    <option value="">Select</option>
    {[...Array(new Date().getFullYear() - 1979)]
      .map((_, index) => new Date().getFullYear() - index)  
      .map((year) => (
        <option key={year} value={year}>{year}</option>
      ))}
  </select>
</label>

 
      </form>

      <div className="buttons">
    
        <button className="next-btn" onClick={handleNextStep}>
        <span>Next</span>
        </button>
      </div>
    </div>
  )}


{currentStep === 1 && (
<div className="contact-details">
<h2 className="title">Enter Contact Details</h2>
<form>
  <label>
    <span className="required">Name:</span>
    <input 
      type="text" 
      name="name" 
      value={contactDetails.name} 
      onChange={handleContactChange} 
      required 
    />
  </label>

  <label>
    <span className="required">Email:</span>
    <input 
      type="email" 
      name="email" 
      value={contactDetails.email} 
      onChange={handleContactChange} 
      required 
    />
  </label>

  <label>
    <span className="required">Phone:</span>
    <input 
      type="tel" 
      name="phone" 
      value={contactDetails.phone} 
      onChange={handleContactChange} 
      required 
    />
  </label>
 
  <label>
    <span className="required">Preferred Contact Method:</span> 
    <div className="contact-method">
      <label>
        <input 
          type="radio" 
          name="contactMethod" 
          value="Email" 
          checked={contactDetails.contactMethod === "Email"} 
          onChange={handleContactChange} 
          required 
        /> 
        <span>Email</span>
      </label>

      <label>
        <input 
          type="radio" 
          name="contactMethod" 
          value="WhatsApp" 
          checked={contactDetails.contactMethod === "WhatsApp"} 
          onChange={handleContactChange} 
          required 
        /> 
        <span>WhatsApp</span>
      </label>
    </div>
  </label>

  
 
</form>

<div className="buttons">
        <button className="prev-btn" onClick={handlePrevStep}>
          
          <span>Back</span>
        </button>
        <button className="next-btn" onClick={handleNextStep}>
        <span>Next</span>
        </button>
      </div>
</div>
)}


{currentStep === 2 && (
<div className="review-submit">
<h2 className="title">Review & Submit</h2>

<div className="review-container">
<div className="user-review-container">
    
    <table>
      <thead>
        <tr>
          <th>Contact Details</th>
          <th>Information</th>
        </tr>
      </thead>
      <tbody>
        <tr><td>Name:</td><td>{contactDetails.name}</td></tr>
         <tr><td>Phone:</td><td>{contactDetails.phone}</td></tr>
      </tbody>
    </table>

 




  </div>
  <div className="car-review-container">
    
    <table>
      <thead>
        <tr>
          <th>Vehicle Details</th>
          <th>Information</th>
        </tr>
      </thead>
      <tbody>
         <tr><td>Make:</td><td>{vehicleDetails.make}</td></tr>
        <tr><td>Model:</td><td>{vehicleDetails.model}</td></tr>
        <tr><td>Year:</td><td>{vehicleDetails.year}</td></tr>
  
       </tbody>
    </table>
  </div>


</div>

<div className="buttons">
  <button className="prev-btn" onClick={handlePrevStep}> <span>Back</span></button>
 
  <button className="submit-btn" onClick={handleSubmit}> {isLoading ? "processing..." : "Submit"}</button>
</div>
</div>
)}
</>
)}

    </div>
        <div className="imports-cars-container">
          <h2>
            Available Units
          </h2>
<Container class1="search-wrapper home-wrapper-2 py-5">
        <div className="row vehicle-row ">
          
          <div className=" search-container  position-relative">
        <FilterForm/>

                            <p className="totalproducts">{filteredProducts.length} Vehicles</p>

            <div className="products-list   ">
                         {currentItems.length === 0 ? (
                 <div className="no-results">
                   <img src={noResults} alt="no results gif"/>
                  </div>
               ) : (
         <>           
            {isDesktop ? (

            <>
            <div className="grid-section grid-three">
              {currentItems.slice(0, 20).map((product, index) => (
                <ProductCard key={index} data={product} grid={grid} />
              ))}
            </div>

            </>):(
         <div className="search-list ">
         {currentItems.map((product, index) => (
           <ProductCard key={index} data={product}  />
         ))}
       </div>
)}
</> )}

            </div>


          </div>
        </div>
     
 
               <Pagination
            pageCount={pageCount}
            handlePageChange={handlePageChange}
            currentPage={currentPage}
          />
          
        {showFilter && renderFilter()} 

      </Container>
        </div>
        
    </div>

    </>

  );
};

export default Sellcar;
